import Box from '../../Box/Box';
import { memo } from 'react';
import Image from '../../Image/Image';
import { LobbyTimerProps } from './LobbyTimer.types';

function LobbyTimer({ children, name = 'common.Clock' }: LobbyTimerProps) {
  return (
    <Box position="absolute" alignItems="center" top="space-0" width={120}>
      <Box
        position="absolute"
        top="space-0"
        transform={'translateY(-10px)'}
        height={24}
        variant="gradient"
        borderRadius="radius-600"
        gradient="warningBackground"
        flexDirection="row"
        gap="space-100"
        justifyContent="center"
        alignItems="center"
        paddingVertical="space-050"
        paddingHorizontal="space-200"
        maxWidth={350}
      >
        <Image contentFit="contain" name={name} width={20} height={20} />
        <Box flexDirection="row" gap="space-050">
          {children}
        </Box>
      </Box>
    </Box>
  );
}

export default memo(LobbyTimer);
